

export function FrequencyTable(props) {
  return (
    <div>
      <canvas width="1350" height="300" ref={props.canvas} />;
    </div>
  )
}